import { createContext } from 'react'

const noop = () => {}

interface Context {
  shouldEditBillingAddress: boolean
  editBillingAddress: (value) => void
  shouldProceedToBuy: boolean
  setProceedToBuy: (value) => void
  setBillingAddressCorrection: () => any
}

const BillingAddressContext = createContext<Context>({
  shouldEditBillingAddress: false,
  editBillingAddress: noop,
  shouldProceedToBuy: false,
  setProceedToBuy: noop,
  setBillingAddressCorrection: noop
})

export default BillingAddressContext
